export default [
    {
        path: '/',
        name:'index',
        meta: { title: '首页',affix: true},
        component: () => import('../../views/homePage.vue')
    }
]